
import { Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";

const TicketButton = ({ ticketNumber, disabled}) => {
  const history = useHistory();

  const handleClick = () => {
    history.push(`/IEPFReport/${ticketNumber}`);
  };

  return (
    <Button
      variant="text"
      size="small"
      style={{
        textTransform: "none",
        color: "#3f51b5",
        padding: "0",
        
      }}
      disabled={disabled}
      onClick={handleClick}
    >
      {ticketNumber}
    </Button>
  );
};

export default TicketButton;
TicketButton.propTypes = {
  ticketNumber: PropTypes.string.isRequired,
  // ticketId: PropTypes.string.isRequired,
  disabled:PropTypes.bool,
};